module.exports = __webpack_public_path__ + "static/img/longyan.40d426ee.png";